var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoYoutubeIcon = function SvgLogoYoutubeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.538 6.346a2.733 2.733 0 0 0-1.945-1.898C18.87 4 12 4 12 4s-6.887 0-8.593.448c-.94.246-1.69.972-1.945 1.898C1 8.012 1 11.5 1 11.5s0 3.488.462 5.154a2.733 2.733 0 0 0 1.945 1.898C5.13 19 12 19 12 19s6.887 0 8.593-.448a2.733 2.733 0 0 0 1.945-1.898C23 14.988 23 11.5 23 11.5s0-3.488-.462-5.154ZM9.752 14.664V8.336l5.755 3.164-5.755 3.164Z",
    fill: "#A4A7AD"
  })));
};
export default SvgLogoYoutubeIcon;